"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeRedirect = void 0;
const RouteInterceptor_1 = require("../RouteInterceptor");
/**
 * Redirects when invoked.
 *
 *
 * @example Usage
 * ```typescript
 * {
 *  path: "my-route",
 *  interceptors: [
 *    routeRedirect("some-other-route"),
 *    routeRedirect((context) => "someOtherRoute"),
 *  ],
 * },
 * ```
 * @param to Either a string or a function to invoke that returns a string.
 * @category Interceptor
 */
const routeRedirect = (to) => ({ context }) => {
    return { kind: RouteInterceptor_1.RouteAction.REDIRECT, to: typeof to === "function" ? to(context) : to };
};
exports.routeRedirect = routeRedirect;
